import { Params, Router } from '@angular/router';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { NotificationType } from '@modules/notification-queue/types/notification.type';
import { ServiceRequestFlagsSignalRInterface } from '@interfaces/singnal-r/service-request-flags-signal-r.interface';

@Component({
  template: '',
})
export abstract class NotificationComponent {
  @Input() notification: NotificationType | ServiceRequestFlagsSignalRInterface | null = null;

  @Output() notificationClose: EventEmitter<string> = new EventEmitter();

  protected constructor(
    private readonly router: Router,
  ) {
  }

  /**
   * Navigates to provided page with spicfied query params and closes notification
   * @param serviceRequestId - service request id to view
   * @param notificationId - notification id to close
   * @param targetUrl - target url where user should be navigated
   * @param queryParams - target url where user should be navigated
   */
  async onViewServiceRequest(
    serviceRequestId: null | string, notificationId: string, targetUrl: string, queryParams: Params = {}
  ): Promise<void> {
    const currentUrl = this.router.url;

    if (currentUrl.includes(targetUrl)) {
      // Angular does not reload a route's component if navigating to the same route with different parameters.
      // Since modifying `onSameUrlNavigation` globally and refactoring isn't possible,
      // this workaround forces a component reload by navigating away and then back again—only when already on the same route
      // This ensures component reinitialization and correct parameter usage.
      await this.router.navigateByUrl('/', { skipLocationChange: true });
    }

    const url = targetUrl + (serviceRequestId ? serviceRequestId : '');

    await this.router.navigate([url], { queryParams });

    this.closeNotification(notificationId);
  }

  /**
   * Close the notification window
   * @param notificationId - notification id to close
   */
  closeNotification(notificationId: string): void {
    this.notificationClose.emit(notificationId);
  }
}
